<template>
    <article class="backgroundText" :style="[getPosition, getSize, getTextStyle]" v-html="properties.text"></article>
</template>

<script>
export default {
    props: ["properties", "pageData"],
    computed: {
      getPosition() {
      
      var negativeMargin = parseInt(this.$store.getters.getMaximizedSizeAndOffsetValue.left);
      var xPosition = this.properties.positionData.xPosition;
      
      if(this.properties.snapToSide == "Left"){
        xPosition += negativeMargin;
      } else  if(this.properties.snapToSide == "Right"){
        xPosition -= negativeMargin;
      } 
      
      return {
          left: xPosition + 'px',
          top: this.properties.positionData.yPosition + 'px'
      }
    },
        getSize() {
            return {
                width: this.properties.componentSize.width !== '' ? this.properties.componentSize.width : 'auto',
                height: this.properties.componentSize.height !== '' ? this.properties.componentSize.height : 'auto' 
            }
        },
        getTextStyle() {
        return {
                color: this.properties.textColor,
                'font-size': `${this.properties.fontSize}px`,
                'text-shadow': this.properties.textShadow,
                'line-height': this.properties.lineHeight !== 0 ? `${this.properties.lineHeight}px` : 'inherit',
                'pointer-events': this.properties.allowSelection === false ? 'none' : 'all'
            }
        }
    }
};
</script>

<style lang="scss">
.backgroundText {
    position: absolute;

    * {
        font-size: inherit;
    }
}
</style>